import { useNavigate } from 'react-router-dom';
import { useTestResult } from '@/hooks/useTestResult';
import PortfolioView from '@/pages/dashboard/components/PortfolioView';

export default function MyResults() {
  const navigate = useNavigate();
  const { student } = useTestResult();

  return (
    <div className="min-h-screen bg-background-50">
      <header className="bg-white border-b border-background-200 print:hidden">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
          <button
            onClick={() => navigate('/dashboard')}
            className="flex items-center gap-2 text-foreground-600 hover:text-foreground-900 text-sm transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            대시보드로 돌아가기
          </button>
          <div className="text-sm font-semibold text-foreground-950">내 검사결과</div>
          <div className="w-24" />
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 md:px-6 py-8">
        {student ? (
          <PortfolioView student={student} />
        ) : (
          <div className="bg-white rounded-xl border border-background-200 p-10 text-center">
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-3">
              <i className="ri-file-list-3-line text-2xl"></i>
            </div>
            <h1 className="font-heading text-lg font-bold text-foreground-950 mb-2">
              검사 결과가 없습니다
            </h1>
            <p className="text-foreground-500 text-sm">
              아직 진행한 검사가 없습니다. 검사를 진행하면 결과가 자동으로 저장되어 여기에서 확인하고 인쇄할 수 있어요.
            </p>
          </div>
        )}
      </main>
    </div>
  );
}